import { useSuspenseQuery } from "@apollo/client";
import {
    BusinessCode,
    PaymentAndAddressDocument,
    PaymentAndAddressQuery,
    PaymentAndAddressQueryVariables,
} from "generated/graphql";

export const usePaymentsAndAddress = () => {
    const { data } = useSuspenseQuery<
        PaymentAndAddressQuery,
        PaymentAndAddressQueryVariables
    >(PaymentAndAddressDocument, {
        variables: {
            businessCode: (process.env.NEXT_PUBLIC_BUSINESS_CODE ||
                BusinessCode.Ub) as BusinessCode,
        },
    });
    if (data.me?.__typename !== "Customer") {
        return {
            savedPaymentMethods: [],
            address: undefined,
        };
    }

    const savedPaymentMethods = data.me.savedPaymentMethods;
    const address = data.me.address;

    return {
        customerId: data.me._id,
        savedPaymentMethods,
        address,
    };
};
